module.exports = __webpack_public_path__ + "static/media/background-image2.c3f8da69.png";